/** Sort direction for a single sortable table column. */
export type SortDirection = 'asc' | 'desc';

export interface SortState<TField extends string> {
  field: TField;
  direction: SortDirection;
}

/**
 * Derives the next sort state when a sortable column header is clicked —
 * shared by every data table (Portfolio, Vaults, Risk & Liquidity, Activity,
 * Reports) so each feature doesn't re-implement the same "click same column
 * to flip direction, click a new column to sort ascending" behavior.
 *
 * Clicking the currently-sorted field flips its direction; clicking any
 * other field starts that field sorting ascending.
 */
export function toggleSort<TField extends string>(
  current: SortState<TField> | undefined,
  field: TField
): SortState<TField> {
  if (current?.field === field) {
    return { field, direction: current.direction === 'asc' ? 'desc' : 'asc' };
  }
  return { field, direction: 'asc' };
}
